import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CardDropdown from 'components/common/CardDropdown';
import FalconCardHeader from 'components/common/FalconCardHeader';
import React from 'react';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import CagegorywiseSummaryPieChart from './CagegorywiseSummaryPieChart';
import EcomStat from 'components/EcomStat';
import { getDashboard_supportServicesSummary } from 'functions/dashboard';
import { useState } from 'react';
import { useEffect } from 'react';
import moment from 'moment';

const CagegorywiseSummaryPieSummary = ({fromDate, toDate, companyId}) => {

  useEffect(()=>{
    loadTableData_Date(fromDate, toDate, companyId)
    }
    ,[fromDate, toDate, companyId])
    
    const [tableData, setTableData] = useState([
      {
        // id: 1,
        // date: '30.10.2023',
        // totalSupportCalls: 10,
        // resolved: 9,
        // permanentlyResolved: 7,
        // temporaryResolved: 2,
        // pending:1
      }
    ]);


    const loadTableData_Date = async (fromDate, toDate, companyId) => {
   
      try {
        const data = {
          fromDate,
          toDate,
          type: 'all',
          companyId: companyId ? companyId : null
        };

        const token = localStorage.getItem('token');
        const tableDataO = await getDashboard_supportServicesSummary(
          data,
          token
        );
        
          setTableData(tableDataO[0]);
        
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

  return (
    <Card className="card h-200">
      <FalconCardHeader
        title={`Support Services - Summary | ${moment(fromDate).format('yyyy MMM DD hh:mm a')} - ${moment(toDate).format('yyyy MMM DD hh:mm a')}`}
        titleTag="h6"
        className="border-200 border-bottom py-2"
        endEl={<CardDropdown />}
      />
      <Card.Body className="p-3 ps-4 d-flex aligm-items-center">
      <EcomStat data={tableData} />
        <CagegorywiseSummaryPieChart data={tableData} />

      </Card.Body>

    </Card>
  );
};

export default CagegorywiseSummaryPieSummary;
